import axios from "axios";
import { getAttribution } from "../lib/tracking";
import { trackEvent } from "../analytics/ga4";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Contact service — Task 17: every submission persists as a lead (MongoDB)
// and shows in the admin leads table. Errors are surfaced to the caller.
// Task 21: attribution (origin page, landing, referrer, UTM) is attached.
export const contactService = {
  async submitPartnershipRequest(data) {
    const payload = {
      company: data.company,
      contact_name: data.contactName,
      business_email: data.email,
      country: data.country,
      business_type: data.businessType,
      message: data.message,
      ...getAttribution(),
    };
    const res = await axios.post(`${API}/contact/demo`, payload, { timeout: 10000 });
    trackEvent("generate_lead", { source: "partnership_form" }); // Task 20 — GA4 conversion
    return { success: true, data: res.data, source: "api" };
  },
};
